import React, { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { IconButton, Toolbar, Button, Typography, TextField, Tooltip, Autocomplete } from '@mui/material';

import { Add, Delete, Edit, Search, Clear, Check, StarOutline, Star, Abc } from '@mui/icons-material/';
import { useNavigate } from 'react-router-dom';

import MyLayout from './layout/layout';
import { routeName } from '../routes/paths';
import axios from '../AxiosInstance';
import useNotification from '../components/notification';
import ConfirmDialog from '../components/ConfirmDialog';

export default function Products() {
  const [searchProductValue, setSearchProductValue] = useState('');
  const [searchBrandValue, setSearchBrandValue] = useState('');
  const { sendNotification } = useNotification();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [filterProducts, setFilterProducts] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [brands, setBrands] = useState([]);

  const navigate = useNavigate();
  const columns = [
    { field: 'id', headerName: 'id', width: 60 },
    {
      field: 'mainPic',
      headerName: 'รูปสินค้า',
      renderCell: (params) => {
        return <img src={params.value} alt='' height={50} width={50} style={{ objectFit: 'cover' }} />;
      },
    },
    {
      field: 'brandName',
      headerName: 'แบรนด์',
      width: 150,
    },
    {
      field: 'name',
      headerName: 'ชื่อสินค้า',
      // hide: true,
      width: 250,
    },
    {
      field: 'categories',
      headerName: 'ประเภท',
      width: 250,
    },
    {
      field: 'inStock',
      headerName: 'มีสต๊อค',
      renderCell: (params) => {
        return params.value ? <Check color='success' /> : <Clear color='error' />;
      },
    },
    {
      field: 'skus',
      headerName: 'ตัวเลือกสินค้า',
    },
    {
      field: 'homepage',
      width: 150,
      disableColumnMenu: true,
      sortable: false,
      headerAlign: 'center',
      headerName: 'Action',
      renderCell: (params) => {
        return (
          <React.Fragment>
            <Tooltip title='ขึ้นหน้าแรก' placement='top'>
              <IconButton
                onClick={() => {
                  let temp = [...products];
                  let sel = temp.find((brand) => brand.id === params.id);
                  sel.homepage = !params.value;
                  setProducts(temp);
                  axios.put(`/products/${params.id}`, { homepage: sel.homepage }).catch((err) => {
                    console.error(err.response);
                    sendNotification({ msg: 'Something wrong open console', variant: 'error' });
                  });
                }}>
                {params.value ? <Star /> : <StarOutline />}
              </IconButton>
            </Tooltip>
            <IconButton
              //   color='warning'
              onClick={() => {
                navigate(`${routeName.PRODUCTS}${params.id}`);
              }}>
              <Edit />
            </IconButton>
            <IconButton
              color='error'
              onClick={() => {
                setOpenDialog(true);
                setSelectedProduct(params.id);
              }}>
              <Delete />
            </IconButton>
          </React.Fragment>
        );
      },
      disableClickEventBubbling: true,
    },
  ];

  const fetchData = () => {
    axios
      .get(`/products/`)
      .then((res) => {
        // console.log(res.data);
        let rawData = res.data.data;
        const data = rawData.map((row) => {
          let inStock = false;
          if (row.skus) {
            for (let sku of row.skus) {
              if (sku.inStock) inStock = true;
            }
          }
          return {
            id: row.id,
            mainPic: row.mainPic,
            brandName: row.brand.name,
            name: row.name,
            categories: row.categories
              .map((cat) => cat.name)
              ?.toString()
              .replace(/,/g, ' > '),
            inStock: inStock,
            skus: row.skus?.length,
            homepage: row.homepage,
          };
        });

        // console.log([...new Set(data.map((row) => row.brandName))]);
        setBrands([...new Set(data.map((row) => row.brandName))]);
        setProducts(data.sort((a, b) => Number(b.homepage) - Number(a.homepage)));
        setFilterProducts(data.sort((a, b) => Number(b.homepage) - Number(a.homepage)));
        setLoading(false);
        // sendNotification({ msg: `Delete reportId : ${selectedReport.id}`, variant: 'success' });
      })
      .catch((err) => {
        console.error(err, 'error');
        setLoading(false);
        sendNotification({ msg: 'Something wrong open console', variant: 'error' });
      });
  };
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    let result = products;
    // filter brand name
    result = result.filter((item) => item.brandName?.toLocaleLowerCase().includes(searchBrandValue));
    // filter product name
    result = result.filter((item) => item.name?.toLocaleLowerCase().indexOf(searchProductValue) > -1);
    setFilterProducts(result);
  }, [searchBrandValue, searchProductValue, products]);

  const handleProductSearch = (e) => {
    const keyword = e.target.value.toLocaleLowerCase();
    setSearchProductValue(keyword);
  };

  const handleBrandSearch = (e, newValue) => {
    const keyword = newValue?.toLocaleLowerCase() || '';
    setSearchBrandValue(keyword);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const handleDeleteSubmit = async () => {
    setOpenDialog(false);
    axios
      .delete(`/products/${selectedProduct}`)
      .then((res) => {
        // console.error(err.response);
        sendNotification({ msg: `Delete product : ${selectedProduct}`, variant: 'success' });
        fetchData();
      })
      .catch((err) => {
        console.error(err.response);
        sendNotification({ msg: 'Something wrong open console', variant: 'error' });
      });
  };

  function escapeRegExp(value) {
    return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
  }
  return (
    <MyLayout>
      <Toolbar>
        <Typography variant='h6' noWrap component='div' sx={{ flexGrow: 1 }}>
          Products
        </Typography>
        <Autocomplete
          value={searchBrandValue}
          onChange={handleBrandSearch}
          options={brands}
          renderInput={(params) => <TextField sx={{ width: '235px' }} {...params} label='Search Brand' size='small' />}
        />
        <TextField
          label='Search product'
          value={searchProductValue}
          sx={{ mx: 2 }}
          size='small'
          InputProps={{
            endAdornment: <Search />,
          }}
          onChange={handleProductSearch}
        />
        <Button
          startIcon={<Add />}
          variant='outlined'
          onClick={() => {
            navigate(`/products/add`);
          }}>
          Add Product
        </Button>
      </Toolbar>
      <DataGrid rows={filterProducts} columns={columns} autoHeight loading={loading} disableSelectionOnClick />
      <ConfirmDialog
        title='Delete Build?'
        content={`Are you sure to delete Product?`}
        submitText='Delete'
        open={openDialog}
        onClose={handleDialogClose}
        onSubmit={handleDeleteSubmit}
      />
    </MyLayout>
  );
}
